<template>
    <component :element='element' :is="customElement"></component>
</template>

<script>
import { defineAsyncComponent } from 'vue'

export default {
    props: ['element'],
    computed: {
        customElement() {
            return defineAsyncComponent(() => import(`@/page_builder/custom_elements/${this.element.custom_element_config.component_name}/${this.element.custom_element_config.component_name}.vue`))
        }
    }
}
</script>